export default `
uniform sampler2D uShield;
uniform sampler2D uGitlines;
uniform sampler2D uMask;
uniform sampler2D uBlur;
uniform sampler2D uHalo;
uniform sampler2D uShieldBack;
uniform float uTime;
uniform float uBeatSpeed;
uniform vec4 uProgress;

uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform vec3 uColor4;

uniform vec3 uBgColor;
uniform vec3 uGlowColor;
uniform vec2 uResolution;
varying vec2 vUv;


void main(){
  vec2 st = (vUv - 0.5) * uResolution / min(uResolution.x, uResolution.y);
  float gitlineColorMap = length(st);

  vec3 gitlineColor = mix(uColor1, uColor2, smoothstep(0.1, 0.3, gitlineColorMap));
  gitlineColor = mix(gitlineColor, uColor3, smoothstep(0.3, 0.5, gitlineColorMap));
  gitlineColor = mix(gitlineColor, uColor4, smoothstep(0.5, 1.0, gitlineColorMap));

  vec4 shield = texture2D(uShield, vUv);
  vec4 gitlines = texture2D(uGitlines, vUv);
  vec4 shieldBack = texture2D(uShieldBack, vUv);

  vec4 halo = texture2D(uHalo, vUv);

  float beat = fract(uTime * uBeatSpeed - 0.2);


  float haloIntensity = smoothstep(0.0, 0.2, beat);
  float haloScale = mix(1.75, 1.0, haloIntensity);

  vec3 grayShield = vec3(shield.r + shield.g + shield.b) * 0.333;

  float mask = texture2D(uMask, vUv).r;
  float blur = texture2D(uBlur, vUv).r;
  blur = pow(blur, 2.0) * 1.4 + pow(blur, 3.0) * 1.5 + blur * 0.8;
  mask += blur * 1.5;

  mask *= uProgress.x;

  gitlineColor = mix(vec3(0.0), gitlineColor, gitlines.r);

  vec3 color = vec3(0.0);
  color = mix(uBgColor, gitlineColor, 0.3 * smoothstep(0.0, 0.2, gitlines.a));

  vec3 glowColor = uGlowColor;
  vec3 hsv = rgb2hsv(glowColor);
  hsv.x += 0.1 * blur + mask * mask * 0.05;
  hsv.y += 0.1 * mask + 0.2;

  glowColor = hsv2rgb(hsv);
  color = color + halo.rgb * haloScale * halo.a + glowColor * mask;
  color = mix(color, shield.rgb, shield.a);

  float outlineAlpha = shieldBack.a - shield.a;
  float outlineIntensity = shieldBack.r;

  color += outlineAlpha * outlineIntensity;
  color = mix(uBgColor, color, smoothstep(0.2, 0.5, vUv.y));

  gl_FragColor = vec4(color, 1.0);
}
`
